module.exports = __webpack_public_path__ + "img/Ballon_alluminium.9133dab.jpg";